import * as Sentry from '@sentry/browser';

/**
 * Wrapper for commonly used Raven calls
 * ... so we can easier replace getsentry if needed later
 */

type User = Partial<{
  id: number;
  email: string;
}>;
export function setUserContext(user: User = {}) {
  const hasValidUser = !!user.id && !!user.email;
  if (Sentry && hasValidUser) {
    Sentry.getCurrentScope().setUser({
      id: user.id == null ? undefined : String(user.id),
    });
  } else {
    console.warn('Could not initialize Sentry with', user);
  }
}

interface Params {
  level?: Sentry.SeverityLevel;
  extra?: {
    key: string;
    value: string | number;
  };
}

export function captureMessage(message: string = '', params: Params = {}) {
  if (!Sentry) {
    return;
  }
  Sentry.withScope(scope => {
    if (params.extra) {
      scope.setExtra(params.extra.key, params.extra.value);
    }
    Sentry.captureMessage(message, params.level ?? 'info');
  });
}

export function captureException(error: Error = new Error(), params: Params = {}) {
  if (!Sentry) {
    return;
  }
  Sentry.withScope(scope => {
    if (params.extra) {
      scope.setExtra(params.extra.key, params.extra.value);
    }
    scope.setLevel(params.level ?? 'error');
    Sentry.captureException(error);
  });
}
